import muiCreateSpacing from "@material-ui/core/styles/createSpacing";
export var createSpacing = function (options) {
    if (options === void 0) { options = 5; }
    return muiCreateSpacing(options);
};
//# sourceMappingURL=createSpacing.js.map